// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__2wqgv","right":"styles_right__2Q_Yz"};